import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import BrandHeader from "@/components/BrandHeader";
import BrandFooter from "@/components/BrandFooter";

/**
 * Shared long-form legal page layout.
 * Renders an array of sections: [{ heading, paragraphs: [string], list?: [string] }]
 */
export default function LegalPage({ title, updated, intro, sections, testId }) {
  return (
    <div className="min-h-screen bg-white text-[#333333]" data-testid={testId}>
      <BrandHeader variant="cream" />

      <div className="max-w-5xl mx-auto px-6 md:px-10 pt-6 flex items-center gap-2 text-xs text-[#8A8A8A]">
        <Link to="/" className="hover:text-[#333333]">Wishing Wellness</Link>
        <ChevronRight className="h-3.5 w-3.5" />
        <span className="text-[#333333] font-semibold">{title}</span>
      </div>

      <section className="pt-10 pb-8 md:pt-16 md:pb-12">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <p className="text-xs font-bold tracking-[0.25em] uppercase text-[#8FAF8A] mb-4">Legal</p>
          <h1 className="font-serif-display text-5xl sm:text-6xl font-medium tracking-tight text-[#333333] leading-[1.05]">
            {title}
          </h1>
          <p className="mt-4 text-sm text-[#8A8A8A]">Last updated: {updated}</p>
          {intro && (
            <p className="mt-8 text-lg text-[#4A4A4A] leading-relaxed">{intro}</p>
          )}
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-3xl mx-auto px-6 md:px-10 space-y-10">
          {sections.map((s, i) => (
            <div key={i} data-testid={`legal-section-${i + 1}`}>
              <h2 className="font-display font-bold text-2xl text-[#333333] mb-4">{s.heading}</h2>
              <div className="space-y-4 text-[#4A4A4A] leading-relaxed">
                {s.paragraphs?.map((p, j) => <p key={j}>{p}</p>)}
                {s.list && (
                  <ul className="list-disc pl-6 space-y-2">
                    {s.list.map((li, j) => <li key={j}>{li}</li>)}
                  </ul>
                )}
              </div>
            </div>
          ))}
          <div className="pt-8 border-t border-[#EDE9E1] text-sm text-[#8A8A8A]">
            Questions? Reach us at{" "}
            <a href="mailto:support@wishingwellnesslife.com" className="text-[#333333] font-semibold hover:underline">
              support@wishingwellnesslife.com
            </a>.
          </div>
        </div>
      </section>

      <BrandFooter />
    </div>
  );
}
